import { VBScrollspy } from './scrollspy';
import { pluginFactory } from '../../utils/plugins';
var VBScrollspyPlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBScrollspy: VBScrollspy
  }
});
export { VBScrollspyPlugin, VBScrollspy };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/scrollspy/index.js
// module id = fpB4
// module chunks = 0